<app-title-bar rootBreadCrumbs="['i18n.core.navigation.vendor-score-card']" titleText="i18n.core.navigation.vendor-score-card-administration"></app-title-bar>
<div class="control-section overflow-x">
  <div class="grid-additional-info">
    <b>{{'i18n.domain.vendor-score-card.vendor-score-card-administration.weighted-cat-total' | translate}}:</b> {{weightedCatSum}}%
  </div>
  <ejs-grid #grid
            class="grid-with-toolbar"
            width='100%'
            rowHeight='38'
            [dataSource]='data'
            [allowSorting]='false'
            [filterSettings]='filterSettings'
            [allowFiltering]='false'
            [allowPaging]='false'
            [enableHover]='false'
            [allowSelection]='false'
            [pageSettings]='pageSettings'
            [editSettings]='customEditSettings'
            [toolbar]="toolbarOptions"
            [searchSettings]="searchOptions"
            (actionBegin)="actionBegin($event)"
            (actionComplete)="actionComplete($event)"
            (cellEdit)="cellEdit($event)"
            (dataBound)="onDataBound($event)"
            (rowDataBound)="onRowDataBound($event)"
            (cellSaved)="onCellSaved($event)"
            (toolbarClick)="clickHandler($event)"
            >
    <e-columns>
      <e-column field='{{columnRowType}}'
                [visible]='true'
                clipMode="EllipsisWithTooltip"
                headerText="{{'i18n.domain.vendor-score-card.vendor-score-card-administration.row' | translate}}"
                isPrimaryKey="true">
                <ng-template #template let-data>
                  <div [innerHTML]="getRowTypeHtml(data.rowType)"></div>
                </ng-template>
              </e-column>
      <e-column field='{{columnWeightedCat}}' width="150"
                headerText="{{'i18n.domain.vendor-score-card.vendor-score-card-administration.weighted-cat' | translate}}"
                clipMode='EllipsisWithTooltip'
                type="number"
                format="N2"
                [validationRules]='numericCellValidationRules'
                >
                <ng-template #template let-data>
                  <div>{{displayData(data.weightedCat, data.rowType, columnWeightedCat)}}</div>
                </ng-template>
      </e-column>
      <e-column field='{{columnWeightedSub}}' width="150"
                headerText="{{'i18n.domain.vendor-score-card.vendor-score-card-administration.weighted-sub' | translate}}"
                clipMode='EllipsisWithTooltip'
                type="number"
                format="N2"
                [validationRules]='numericCellValidationRules'
                >
                <ng-template #template let-data>
                  <div>{{displayData(data.weightedSub, data.rowType, columnWeightedSub)}}</div>
                </ng-template>
      </e-column>
      <e-column field='{{columnTenPointsReference}}' width="150"
                headerText="{{'i18n.domain.vendor-score-card.vendor-score-card-administration.ten-points-reference' | translate}}"
                clipMode='EllipsisWithTooltip'
                type="number"
                >
                <ng-template #template let-data>
                  <div>{{displayData(data.tenPointsReference, data.rowType, columnTenPointsReference)}}</div>
                </ng-template>
      </e-column>
      <e-column field='{{columnOnePointReference}}' width="150"
                headerText="{{'i18n.domain.vendor-score-card.vendor-score-card-administration.one-point-reference' | translate}}"
                clipMode='EllipsisWithTooltip'
                type="number"
                >
                <ng-template #template let-data>
                  <div>{{displayData(data.onePointReference, data.rowType, columnOnePointReference)}}</div>
                </ng-template>
      </e-column>
    </e-columns>
  </ejs-grid>
</div>